// extracted by mini-css-extract-plugin
export var container = "Sales-module--container--I-PHa";
export var content = "Sales-module--content--UUpVZ";
export var noSuppliers = "Sales-module--noSuppliers--QIyGe";
export var subHeader = "Sales-module--subHeader--RNj-l";